// extracted by mini-css-extract-plugin
export default {"title":"PlusSlider_title__v1ZES","details":"PlusSlider_details__QslzK","slidermain":"PlusSlider_slidermain__0FzDN","sliderCard":"PlusSlider_sliderCard__KCe7S"};